/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Save_PreferencesInputs */

const en_cookies_save_preferences = /** @type {(inputs: Cookies_Save_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save preferences`)
};

const pl_cookies_save_preferences = /** @type {(inputs: Cookies_Save_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz ustawienia`)
};

/**
* | output |
* | --- |
* | "Save preferences" |
*
* @param {Cookies_Save_PreferencesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_save_preferences = /** @type {((inputs?: Cookies_Save_PreferencesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Save_PreferencesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_save_preferences(inputs)
	return en_cookies_save_preferences(inputs)
});